import mixpanel from 'mixpanel-browser';

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);

const allowTracking = () => {
  return process.env.REACT_APP_ENV === 'prod';
};

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);

const actions = {
  track: (message, props) => {
    if (allowTracking()) mixpanel.track(message, props);
  },
  identify: (id) => {
    if (allowTracking()) mixpanel.identify(id);
  },
  group: {
    create: (id) => {
      if (allowTracking()) {
        mixpanel.set_group('company', id);
      }
    },
    set: (id, props) => {
      if (allowTracking()) {
        mixpanel.get_group('company', id).set(props);
      }
    }
  },
  people: {
    set: (props) => {
      if (allowTracking()) mixpanel.people.set(props);
    }
  }
};

export const Mixpanel = actions;

export const trackingMessages = {
  // Global
  log_in: 'Log In',
  log_out: 'Log Out',

  // Home
  accessed_home: 'Accessed home',
  opened_video_overview_sdp: 'Opened video: Overview SDP',
  opened_video_how_to_create_job: 'Opened video: How to create a Job',
  opened_video_how_to_create_pipeline: 'Opened video: How to create a Pipeline',
  opened_video_how_to_work_on_sandbox: 'Opened video: How to work on Sandbox',

  // Pipelines
  accessed_pipelines: 'Accessed pipelines',
  created_pipeline: 'Created pipeline',
  deleted_pipeline: 'Deleted pipeline',
  enabled_pipeline: 'Enabled pipeline',
  disabled_pipeline: 'Disabled pipeline',
  updated_pipeline_scheduler: 'Updated pipeline scheduler',
  updated_pipeline_settings: 'Updated pipeline settings',
  accessed_pipeline_resources: 'Accessed pipeline resources',
  updated_pipeline_resources: 'Updated pipeline settings',
  accessed_pipeline_logs: 'Accessed pipeline logs',
  accessed_pipeline_documentation: 'Accessed pipeline documentation',

  // Jobs
  accessed_jobs: 'Accessed jobs',
  created_job: 'Created job',
  deleted_job: 'Deleted job',
  enabled_job: 'Enabled job',
  disabled_job: 'Disabled job',
  updated_job_information: 'Updated pipeline information',
  accessed_job_logs: 'Accessed job logs',
  updated_trigger_step: 'Updated trigger step',
  updated_SQL_step: 'Updated SQL step',
  updated_PySpark_step: 'Updated PySpark step',
  updated_job: 'Updated job',
  accessed_job_documentation: 'Accessed job documentation',

  // Visualize
  accessed_visualize: 'Accessed visualize',
  accessed_visualize_documentation: 'Accessed visualize documentation',

  // Sandbox
  accessed_sandbox: 'Accessed sandbox',
  accessed_sandbox_documentation: 'Accessed sandbox documentation',

  // Sandbox
  accessed_catalog: 'Accessed catalog',
  accessed_catalog_documentation: 'Accessed catalog documentation',

  // Chat2dash
  accessed_chat2dash: 'Accessed chat2dash',
  accessed_chat2dash_documentation: 'Accessed chat2dash documentation',

  // Add-ons
  accessed_add_ons: 'Accessed add-ons',
  viwed_add_on_details: 'Viewed add-on details',
  requested_to_use_add_on: 'Requested to use add-On',

  // Management
  accessed_users: 'Accessed users',
  updated_user: 'Updated user',
  deleted_user: 'Deleted user',
  created_user: 'Created user',

  // Support
  requested_support: 'Requested support'
};
